var React = require('react');

function Subscription (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"72","height":"72","rx":"4","fill":"#1B1C21","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M42.9301 28.7027H56V42.9257H42.9301V56H29.07V42.9257H16V28.7027H29.07V16H42.9301V28.7027ZM29.0713 42.7234V28.9397C29.0713 28.7707 29.2688 28.7032 29.4005 28.737L42.7997 35.6289C42.9643 35.7302 42.9643 35.9329 42.7997 36.0005L29.4005 42.8924C29.2688 42.9937 29.0713 42.8924 29.0713 42.7234Z","fill":"#EA6C13","key":1})]);
}

Subscription.defaultProps = {"width":"72","height":"72","viewBox":"0 0 72 72","fill":"none"};

module.exports = Subscription;

Subscription.default = Subscription;
